
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/[isbn]",
      function () {
        return require("private-next-pages/book/[isbn].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/[isbn]"])
      });
    }
  